import { Spinner as CoreSpinner, SpinnerProps as CoreSpinnerProps } from "@blueprintjs/core";
import classNames from "classnames";
import { fun } from "../fun/funContext";
import { type ToneProps, toneClass } from "./tone";

export interface SpinnerProps extends ToneProps, Omit<CoreSpinnerProps, "intent"> {}

export const Spinner = fun("spinner", (props: SpinnerProps) => {
  const { size: controlledSize, ...restProps } = props;
  const size = controlledSize ?? 64;

  return <CoreSpinner {...toNativeProps(restProps)} size={size} />;
});

export function toNativeProps(props: SpinnerProps): CoreSpinnerProps {
  const { tone, className, ...restProps } = props;

  return {
    ...restProps,
    className: classNames(className, toneClass(tone)),
  };
}
